<script>
  export let data = { subscription: { productName: '' } },
    contact;

  const productName = data.subscription?.productName || '';
</script>

{productName}
